(() => {
  if (window.hokoAccessoriesLoaded) return;
  window.hokoAccessoriesLoaded = true;

  const text = (tag, className, value) => {
    const node = document.createElement(tag);
    node.className = className;
    node.textContent = value || '';
    return node;
  };

  function cardFor(product, viewDetailsLabel, chooseOptionsLabel, parentProductId, index) {
    const card = text('article', 'hoko-accessories__card');
    const link = document.createElement('a');
    const drawerId = 'hoko-accessory-' + parentProductId + '-' + index + '-' + product.id;
    link.className = 'hoko-accessories__link';
    link.href = product.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', product.title);
    const imageBox = text('span', 'hoko-accessories__image');
    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      imageBox.append(image);
    }
    link.append(imageBox, text('span', 'hoko-accessories__name', product.title));
    const variant = product.variants && product.variants[0];
    const price = text('span', 'hoko-accessories__price');
    if (variant) {
      const locale = document.documentElement.lang || 'de-DE';
      const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR';
      const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
      price.textContent = formatter.format(Number(variant.price) / 100);
      if (Number(variant.compare_at_price) > Number(variant.price)) {
        const compare = document.createElement('s');
        compare.textContent = formatter.format(Number(variant.compare_at_price) / 100);
        price.append(compare);
      }
    }
    link.append(price);
    card.append(link);
    const action = document.createElement('button', { is: 'toggle-button' });
    action.type = 'button';
    action.className = 'hoko-accessories__action';
    action.textContent = chooseOptionsLabel;
    action.setAttribute('aria-controls', drawerId);
    action.setAttribute('aria-expanded', 'false');
    card.append(action);
    const drawer = document.createElement('quick-buy-drawer');
    const drawerUrl = new URL(product.url, window.location.href);
    drawerUrl.searchParams.set('view', 'quick-buy-drawer');
    drawer.id = drawerId;
    drawer.className = 'drawer drawer--large drawer--quick-buy';
    drawer.setAttribute('href', drawerUrl.toString());
    drawer.dataset.productUrl = product.url;
    card.append(drawer);
    return card;
  }

  async function showVariantImages(drawer) {
    const swatches = [...drawer.querySelectorAll('.color-swatch__radio')];
    if (!swatches.length || !drawer.dataset.productUrl) return;
    try {
      const url = new URL(drawer.dataset.productUrl, window.location.href);
      url.search = '';
      url.pathname += '.js';
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const product = await response.json();
      for (const radio of swatches) {
        const position = Number(radio.name.replace('option', '')) - 1;
        const variant = product.variants.find(item => item.options[position] === radio.value && item.featured_image);
        const image = variant?.featured_image?.src;
        const label = radio.nextElementSibling;
        if (!image || !label?.classList.contains('color-swatch__item')) continue;
        const thumbnail = new URL(image, window.location.href);
        thumbnail.searchParams.set('width', '96');
        label.style.backgroundColor = '';
        label.style.backgroundImage = `url("${thumbnail.href}")`;
        label.title = radio.value;
      }
    } catch (error) {
      console.warn('Accessory variant images unavailable', error);
    }
  }

  function initDrawers(root) {
    root.querySelectorAll('quick-buy-drawer[id^="hoko-accessory-"]').forEach(drawer => {
      if (drawer.dataset.hokoInitialized) return;
      drawer.dataset.hokoInitialized = 'true';
      drawer.addEventListener('openable-element:load:end', () => showVariantImages(drawer));
    });
  }

  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('.hoko-accessories__track');
    const previous = root.querySelector('[data-direction="previous"]');
    const next = root.querySelector('[data-direction="next"]');
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .8, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .8, behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (!track.children.length && root.dataset.productId) {
      try {
        const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        const url = base + 'recommendations/products.json?product_id=' + encodeURIComponent(root.dataset.productId) + '&limit=10&intent=related';
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Recommendation request failed');
        const data = await response.json();
        (data.products || []).filter(item => String(item.id) !== root.dataset.productId).forEach((item, index) => track.append(cardFor(item, root.dataset.viewDetailsLabel || 'View details', root.dataset.chooseOptionsLabel || 'Choose options', root.dataset.productId, index + 1)));
      } catch (error) {
        console.warn('Accessory recommendations unavailable', error);
      }
    }
    initDrawers(root);
    if (!track.children.length) root.hidden = true;
    requestAnimationFrame(update);
  }

  function initAll(container = document) {
    container.querySelectorAll('[data-hoko-accessories]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
